import {BaseFormModel} from './base-form-model';
import {MenuItem} from './menu-item';
import {Sortable} from './sortable';

export class MenuItemGroupItem extends BaseFormModel<MenuItemGroupItem> implements Sortable {
    id: number;
    name: string;
    menuItem: MenuItem;
    sortOrder: number;

    getName() {
        return !!this.menuItem ? this.menuItem.name : null;
    }

    init(): void {
        this.menuItem = new MenuItem(this.menuItem);
    }
}
